import React, { useState, useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import {
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TextField,
  Select,
  MenuItem,
  ListSubheader,
  Button,
  CircularProgress,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  CssBaseline,
  AppBar,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { useLocation, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import {
  ExitToApp as ExitToAppIcon,
  ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import {
  fetchData,
  saveOrUpdateData,
  saveVerifyingData1,
  saveComment,
  saveKwComment,
  saveCheckbox,
  getSADAndDrugaWartosc,
  updatePrzygotowaneZweryfikowane,
  updateZweryfikowanePrzygotowaneDoWyslania,
  updateStatusDoPoprawy,
  updateStatusDoWyslania,
  updateStatusWstepnie,
  fetchUserPrivileges,
  saveInternalControlDataDates,
  resetList,
  resetInternalControl,
  fetchLokalizacjaOdprawList,
  fetchLokalizacjaTransportuList,
  fetchKwComments,
} from "../UniwersalListTranzyt/functions";
import ResetListDialog from "../ResetListDialog";

import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  greyRow: {
    backgroundColor: "#dedede !important", // Ensure it overrides default styles
  },
  checkboxesHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableContainer: {
    marginTop: theme.spacing(3),
    border: "1px solid #ddd",
    borderRadius: theme.spacing(1),
    overflowX: "auto",
    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
  },
  tableHeadCell: {
    fontWeight: "bold",
    backgroundColor: "#f9f9f9",
    textAlign: "center",
    padding: theme.spacing(1.5),
    borderBottom: "2px solid #ddd",
  },
  tableSubHeadCell: {
    fontWeight: "bold",
    fontSize: "0.9rem",
    padding: theme.spacing(1),
    borderBottom: "1px solid #ddd",
  },
  checkCell: {
    textAlign: "left",
    fontWeight: "bold",
    padding: theme.spacing(1),
    wordBreak: "break-word",
  },
  inputField: {
    width: "100%",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#eaeaea",
    },
  },
  centered: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pdfContainer: {
    maxWidth: 2300, // Kluczowa szerokość dla PDF
    fontSize: "18px", // czytelna wielkość czcionki
    padding: 10, // padding wokół treści
    backgroundColor: "#ffffff", // białe tło dokumentu PDF
  },
  pdfContainerExport: {
    width: "1400px !important",
    padding: 10,
    backgroundColor: "#ffffff",
    fontSize: "20px !important",
    overflowX: "auto",
  },
}));

const UniwersalListTranzyt = () => {
  const ref = useRef();
  const classes = useStyles();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const queryStateFallback = {
    nrRef: searchParams.get("nrRef") || "",
    osobaPrzygotowujaca: searchParams.get("osobaPrzygotowujaca") || "",
    osobaWeryfikujaca: searchParams.get("osobaWeryfikujaca") || "",
    osobaWysylajaca: searchParams.get("osobaWysylajaca") || "",
    status: searchParams.get("status") || "",
    rodzajOdprawy: searchParams.get("rodzajOdprawy") || "",
    lokalizacjaTowaru: searchParams.get("lokalizacjaTowaru") || "",
    kwDaneId: searchParams.get("kwDaneId") || "",
    returnPath: searchParams.get("returnPath") || "",
    returnLabel: searchParams.get("returnLabel") || "",
  };
  const {
    nrRef,
    osobaPrzygotowujaca,
    osobaWeryfikujaca,
    osobaWysylajaca,
    status,
    rodzajOdprawy,
    lokalizacjaTowaru,
    kwDaneId,
    returnPath,
    returnLabel,
  } = {
    ...queryStateFallback,
    ...(location.state || {}),
  };
  const [privileges, setPrivileges] = useState(null);
  const [wstepniePrzygotowane, setWstepniePrzygotowane] = useState(undefined);
  const [przygotowane, setPrzygotowane] = useState(undefined);
  const { id } = useParams();
  const [isAllPreparedChecked, setIsAllPreparedChecked] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(false);

  const token = localStorage.getItem("token");
  let username;
  let role;

  if (token) {
    const decoded = jwtDecode(token);
    username = decoded.username;
    role = decoded.role;
  }

  const [openResetDialog, setOpenResetDialog] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [comment, setComment] = useState("");
  const [openResetInternalControlDialog, setOpenResetInternalControlDialog] =
    useState(false);
  const [selectedOptionInternalControl, setSelectedOptionInternalControl] =
    useState("");
  const [commentInternalControl, setCommentInternalControl] = useState("");
  const [lokalizacjeOdprawList, setLokalizacjeOdprawList] = useState([]);
  const [lokalizacjeTransportuList, setLokalizacjeTransportuList] = useState(
    [],
  );
  const [openUrzadZgloszeniaDialog, setOpenUrzadZgloszeniaDialog] =
    useState(false);
  const [selectedUrzadZgloszenia, setSelectedUrzadZgloszenia] = useState("");
  const [selectedLokalizacjaTransportu, setSelectedLokalizacjaTransportu] =
    useState("");
  const [urzadSearchTerm, setUrzadSearchTerm] = useState("");
  const [lokalizacjaSearchTerm, setLokalizacjaSearchTerm] = useState("");
  const [pendingDoWyslaniaAction, setPendingDoWyslaniaAction] = useState(null);
  const [currentUrzadZgloszenia, setCurrentUrzadZgloszenia] = useState("");
  const [currentLokalizacjaTransportu, setCurrentLokalizacjaTransportu] =
    useState(lokalizacjaTowaru || "");

  const kwDaneIdFromReturnPath = returnPath
    ? returnPath.match(/\/kontrolaWewnetrzna\/szczegoly\/([^/?#]+)/i)?.[1] || ""
    : "";
  const kwCommentTargetId = kwDaneId || kwDaneIdFromReturnPath || id;
  const [kwComments, setKwComments] = useState([]);

  const handleBackNavigation = () => {
    if (returnPath) {
      navigate(returnPath, {
        state: { fromChecklist: true },
      });
      return;
    }

    navigate(`/detail/${encodeURIComponent(nrRef)}/${encodeURIComponent(id)}`);
  };

  const filteredUrzadZgloszeniaOptions = lokalizacjeOdprawList.filter((item) =>
    String(item.name || "")
      .toLowerCase()
      .includes(urzadSearchTerm.toLowerCase()),
  );

  const filteredLokalizacjaTransportuOptions = lokalizacjeTransportuList.filter(
    (item) =>
      String(item.name || "")
        .toLowerCase()
        .includes(lokalizacjaSearchTerm.toLowerCase()),
  );

  const [data, setData] = useState({
    creationDate: "",
    lastUpdateDate: "",
    osoba_kotrolujaca: "",
    data_kontroli: "",
    textFields: {
      19: { value: "", verifyingPerson: "" },
      20: { value: "", verifyingPerson: "" },
      21: { value: "", verifyingPerson: "" },
      25: { value: "", verifyingPerson: "" },
    },
    selectFields: {
      11: { value: "", verifyingPerson: "" },
      23: { value: "", verifyingPerson: "" },
    },
    checkboxesPreparation: {
      1: { verifying: false, verifyingPerson: "" },
      2: { verifying: false, verifyingPerson: "" },
      3: { verifying: false, verifyingPerson: "" },
      4: { verifying: false, verifyingPerson: "" },
      5: { verifying: false, verifyingPerson: "" },
      6: { verifying: false, verifyingPerson: "" },
      7: { verifying: false, verifyingPerson: "" },
      8: { verifying: false, verifyingPerson: "" },
      9: { verifying: false, verifyingPerson: "" },
      10: { verifying: false, verifyingPerson: "" },
      12: { verifying: false, verifyingPerson: "" },
      13: { verifying: false, verifyingPerson: "" },
      14: { verifying: false, verifyingPerson: "" },
      15: { verifying: false, verifyingPerson: "" },
      16: { verifying: false, verifyingPerson: "" },
      17: { verifying: false, verifyingPerson: "" },
      18: { verifying: false, verifyingPerson: "" },
      22: { verifying: false, verifyingPerson: "" },
      24: { verifying: false, verifyingPerson: "" },
      26: { verifying: false, verifyingPerson: "" },
    },
    checkboxesVerification: {
      1: { good: false, bad: false },
      2: { good: false, bad: false },
      3: { good: false, bad: false },
      4: { good: false, bad: false },
      5: { good: false, bad: false },
      6: { good: false, bad: false },
      7: { good: false, bad: false },
      8: { good: false, bad: false },
      9: { good: false, bad: false },
      10: { good: false, bad: false },
      11: { good: false, bad: false },
      12: { good: false, bad: false },
      13: { good: false, bad: false },
      14: { good: false, bad: false },
      15: { good: false, bad: false },
      16: { good: false, bad: false },
      17: { good: false, bad: false },
      18: { good: false, bad: false },
      19: { good: false, bad: false },
      20: { good: false, bad: false },
      21: { good: false, bad: false },
      22: { good: false, bad: false },
      23: { good: false, bad: false },
      24: { good: false, bad: false },
      25: { good: false, bad: false },
      26: { good: false, bad: false },
    },
    checkboxesInternalControl: {
      1: { good: false, bad: false },
      2: { good: false, bad: false },
      3: { good: false, bad: false },
      4: { good: false, bad: false },
      5: { good: false, bad: false },
      6: { good: false, bad: false },
      7: { good: false, bad: false },
      8: { good: false, bad: false },
      9: { good: false, bad: false },
      10: { good: false, bad: false },
      11: { good: false, bad: false },
      12: { good: false, bad: false },
      13: { good: false, bad: false },
      14: { good: false, bad: false },
      15: { good: false, bad: false },
      16: { good: false, bad: false },
      17: { good: false, bad: false },
      18: { good: false, bad: false },
      19: { good: false, bad: false },
      20: { good: false, bad: false },
      21: { good: false, bad: false },
      22: { good: false, bad: false },
      23: { good: false, bad: false },
      24: { good: false, bad: false },
      25: { good: false, bad: false },
      26: { good: false, bad: false },
    },
    nrRef: "",
    osobaPrzygotowujaca: "",
    osobaWeryfikujaca: "",
    comment: "",
  });

  const [loading, setLoading] = useState(true);
  const [isAllInternalControleSaved, setIsAllInternalControleSaved] =
    useState(false);
  const [allVeryfyingDataFilled, setAllVeryfyingDataFilled] = useState(false);
  const [allVerificationSet, setAllVerificationSet] = useState(false);
  const selectOptions = {
    11: ["TAK", "NIE"],
    23: [
      "CFR",
      "CIF",
      "CIP",
      "CPT",
      "DAP",
      "DDP",
      "DPU",
      "EXW",
      "FAS",
      "FCA",
      "FOB",
    ],
  };

  const loadUserPrivileges = async () => {
    const userPrivileges = await fetchUserPrivileges(username);
    setPrivileges(userPrivileges);
  };

  const columnMapping = {
    "Kontrola wewnętrzna": "internalControl",
    Import: "import",
    Eksport: "export",
    "Wyprowadzenie z magazynu": "warehouseOut",
    "Wprowadzenie na magazyn": "warehouseIn",
    "Uszlachetnianie czynne": "activeRefinement",
    "Uszlachetnianie bierne": "passiveRefinement",
    "Powrotny przywóz": "returnImport",
    "Powrotny wywóz": "returnExport",
    "Import - wpis do rejestru": "importRegisterEntry",
    "Eksport - wpis do rejestru": "exportRegisterEntry",
    "Eksport PL + import": "exportImport",
    Tranzyt: "tranzyt",
  };

  // Funkcja sprawdzająca przywilej dla wybranego rodzaju odprawy
  const checkPrivilege = (userPrivileges, rodzajOdprawy) => {
    if (!userPrivileges) return false;
    const privilegeKey = columnMapping[rodzajOdprawy];
    return privilegeKey ? userPrivileges[privilegeKey] === 1 : false;
  };

  const loadLokalizacjeOdprawList = async () => {
    try {
      const data = await fetchLokalizacjaOdprawList();
      const sortedData = [...data].sort((a, b) => a.name.localeCompare(b.name));
      setLokalizacjeOdprawList(sortedData);
    } catch (error) {
      console.error("Error fetching lokalizacje odpraw list:", error);
    }
  };

  const loadLokalizacjeTransportuList = async () => {
    try {
      const data = await fetchLokalizacjaTransportuList();
      const sortedData = [...data].sort((a, b) => a.name.localeCompare(b.name));
      setLokalizacjeTransportuList(sortedData);
    } catch (error) {
      console.error("Error fetching lokalizacje transportu list:", error);
    }
  };

  // Funkcja sprawdzająca, czy wszystkie wymagane pola są wypełnione
  const areAllRequiredFieldsFilled = (
    data,
    requiredTextFields,
    requiredSelectFields,
    requiredCheckboxes,
  ) => {
    const allTextFieldsFilled = requiredTextFields.every(
      (fieldId) => data.textFields[fieldId]?.value,
    );
    const allSelectFieldsFilled = requiredSelectFields.every(
      (fieldId) => data.selectFields[fieldId]?.value,
    );
    const allCheckboxesChecked = requiredCheckboxes.every(
      (fieldId) => data.checkboxesPreparation[fieldId]?.verifying,
    );
    return allTextFieldsFilled && allSelectFieldsFilled && allCheckboxesChecked;
  };
  const verifyAndSubmit = async (data, status, id, username) => {
    if (status !== "Do przygotowania" && status !== "Wstępnie przygotowane") {
      return "none";
    }

    const requiredTextFields = [19, 20, 21, 25];
    const requiredSelectFields = [11, 23];
    const requiredCheckboxes = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 22, 24, 26,
    ];

    const allRequiredFieldsFilled = areAllRequiredFieldsFilled(
      data,
      requiredTextFields,
      requiredSelectFields,
      requiredCheckboxes,
    );

    try {
      const { SAD, Plik } = await getSADAndDrugaWartosc(id);
      const SADandPlikPresent = SAD && Plik;

      if (SADandPlikPresent && allRequiredFieldsFilled) {
        const hasPrivilege = checkPrivilege(privileges, rodzajOdprawy);
        const newStatus = hasPrivilege ? "Do wysłania" : "Do weryfikacji";

        if (newStatus === "Do wysłania") {
          setPendingDoWyslaniaAction({
            type: "prepared",
            statusNow: status,
          });
          setSelectedUrzadZgloszenia(currentUrzadZgloszenia || "");
          setSelectedLokalizacjaTransportu(currentLokalizacjaTransportu || "");
          setOpenUrzadZgloszeniaDialog(true);
          return "pendingDialog";
        }

        const payload = {
          statusNow: status,
          status: newStatus,
          Przygotowane: 1,
          Zweryfikowane: hasPrivilege ? 1 : 0,
          wstepniePrzygotowane: 1,
          username: username,
        };
        await updateZweryfikowanePrzygotowaneDoWyslania(id, payload, "tranzyt");
        alert("Status zmieniony poprawnie."); // Pokaż wiadomość użytkownikowi
        navigate(
          `/detail/${encodeURIComponent(nrRef)}/${encodeURIComponent(id)}`,
        );
        return "statusChanged";
      } else if (allRequiredFieldsFilled) {
        await updatePrzygotowaneZweryfikowane(
          id,
          { Przygotowane: 1, wstepniePrzygotowane: 1 },
          "tranzyt",
        );
        alert("Status zmieniony poprawnie."); // Pokaż wiadomość użytkownikowi
        navigate(
          `/detail/${encodeURIComponent(nrRef)}/${encodeURIComponent(id)}`,
        );
        return "done";
      } else {
        console.log(
          "Not all required fields are filled. No updates performed.",
        );
      }
    } catch (error) {
      console.error("Failed to update status:", error);
      return "error";
    }

    return "none";
  };

  const allDataSave = (data) => {
    // Definiujemy pola, które chcemy sprawdzić
    const requiredSelectFields = [11];
    const requiredCheckboxes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14];
    const allSelectFieldsFilled = requiredSelectFields.every(
      (fieldId) => data.selectFields[fieldId]?.value,
    );
    const allCheckboxesChecked = requiredCheckboxes.every(
      (fieldId) => data.checkboxesPreparation[fieldId]?.verifying,
    );
    return allSelectFieldsFilled && allCheckboxesChecked;
  };

  const areSpecificFieldsDisabled = allDataSave(data);

  const allInternalControlSave = (data) => {
    const requiredCheckboxes = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26,
    ];

    const allCheckboxesHaveValue = requiredCheckboxes.every(
      (fieldId) =>
        data.checkboxesInternalControl[fieldId] &&
        (data.checkboxesInternalControl[fieldId].good === true ||
          data.checkboxesInternalControl[fieldId].bad === true),
    );

    return allCheckboxesHaveValue;
  };

  const allVeryfyingDataSave = (data) => {
    const requiredCheckboxes = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26,
    ];

    const allCheckboxesHaveValue = requiredCheckboxes.every(
      (fieldId) =>
        data.checkboxesVerification[fieldId] &&
        (data.checkboxesVerification[fieldId].good === true ||
          data.checkboxesVerification[fieldId].bad === true),
    );

    return allCheckboxesHaveValue;
  };

  const checkIfAllVerificationSet = (data) => {
    return Object.keys(data.checkboxesVerification).every(
      (key) =>
        data.checkboxesVerification[key].good !== false ||
        data.checkboxesVerification[key].bad !== false,
    );
  };

  const fetchAndSetData = async () => {
    try {
      const fetchedData = await fetchData(id);
      loadUserPrivileges();

      setWstepniePrzygotowane(fetchedData.wstepniePrzygotowane || 0);
      setPrzygotowane(fetchedData.Przygotowane || 0);
      setCurrentUrzadZgloszenia(fetchedData.urzadZgloszenia || "");
      setCurrentLokalizacjaTransportu(
        fetchedData.lokalizacjaTowaru || lokalizacjaTowaru || "",
      );

      const mappedData = {
        textFields: {
          19: {
            value: fetchedData.field_19 || "",
            verifyingPerson: fetchedData.verifyingPerson_19 || "",
          },
          20: {
            value: fetchedData.field_20 || "",
            verifyingPerson: fetchedData.verifyingPerson_20 || "",
          },
          21: {
            value: fetchedData.field_21 || "",
            verifyingPerson: fetchedData.verifyingPerson_21 || "",
          },
          25: {
            value: fetchedData.field_25 || "",
            verifyingPerson: fetchedData.verifyingPerson_25 || "",
          },
        },
        selectFields: {
          11: {
            value: fetchedData.field_11 || "",
            verifyingPerson: fetchedData.verifyingPerson_11 || "",
          },
          23: {
            value: fetchedData.field_23 || "",
            verifyingPerson: fetchedData.verifyingPerson_23 || "",
          },
        },
        checkboxesPreparation: {
          1: {
            verifying: Boolean(fetchedData.field_1),
            verifyingPerson: fetchedData.verifyingPerson_1 || "",
          },
          2: {
            verifying: Boolean(fetchedData.field_2),
            verifyingPerson: fetchedData.verifyingPerson_2 || "",
          },
          3: {
            verifying: Boolean(fetchedData.field_3),
            verifyingPerson: fetchedData.verifyingPerson_3 || "",
          },
          4: {
            verifying: Boolean(fetchedData.field_4),
            verifyingPerson: fetchedData.verifyingPerson_4 || "",
          },
          5: {
            verifying: Boolean(fetchedData.field_5),
            verifyingPerson: fetchedData.verifyingPerson_5 || "",
          },
          6: {
            verifying: Boolean(fetchedData.field_6),
            verifyingPerson: fetchedData.verifyingPerson_6 || "",
          },
          7: {
            verifying: Boolean(fetchedData.field_7),
            verifyingPerson: fetchedData.verifyingPerson_7 || "",
          },
          8: {
            verifying: Boolean(fetchedData.field_8),
            verifyingPerson: fetchedData.verifyingPerson_8 || "",
          },
          9: {
            verifying: Boolean(fetchedData.field_9),
            verifyingPerson: fetchedData.verifyingPerson_9 || "",
          },
          10: {
            verifying: Boolean(fetchedData.field_10),
            verifyingPerson: fetchedData.verifyingPerson_10 || "",
          },
          12: {
            verifying: Boolean(fetchedData.field_12),
            verifyingPerson: fetchedData.verifyingPerson_12 || "",
          },
          13: {
            verifying: Boolean(fetchedData.field_13),
            verifyingPerson: fetchedData.verifyingPerson_13 || "",
          },
          14: {
            verifying: Boolean(fetchedData.field_14),
            verifyingPerson: fetchedData.verifyingPerson_14 || "",
          },
          15: {
            verifying: Boolean(fetchedData.field_15),
            verifyingPerson: fetchedData.verifyingPerson_15 || "",
          },
          16: {
            verifying: Boolean(fetchedData.field_16),
            verifyingPerson: fetchedData.verifyingPerson_16 || "",
          },
          17: {
            verifying: Boolean(fetchedData.field_17),
            verifyingPerson: fetchedData.verifyingPerson_17 || "",
          },
          18: {
            verifying: Boolean(fetchedData.field_18),
            verifyingPerson: fetchedData.verifyingPerson_18 || "",
          },
          22: {
            verifying: Boolean(fetchedData.field_22),
            verifyingPerson: fetchedData.verifyingPerson_22 || "",
          },
          24: {
            verifying: Boolean(fetchedData.field_24),
            verifyingPerson: fetchedData.verifyingPerson_24 || "",
          },
          26: {
            verifying: Boolean(fetchedData.field_26),
            verifyingPerson: fetchedData.verifyingPerson_26 || "",
          },
        },
        checkboxesVerification: {
          1: {
            good: fetchedData.weryfikacja_1 === 1,
            bad: fetchedData.weryfikacja_1 === 0,
          },
          2: {
            good: fetchedData.weryfikacja_2 === 1,
            bad: fetchedData.weryfikacja_2 === 0,
          },
          3: {
            good: fetchedData.weryfikacja_3 === 1,
            bad: fetchedData.weryfikacja_3 === 0,
          },
          4: {
            good: fetchedData.weryfikacja_4 === 1,
            bad: fetchedData.weryfikacja_4 === 0,
          },
          5: {
            good: fetchedData.weryfikacja_5 === 1,
            bad: fetchedData.weryfikacja_5 === 0,
          },
          6: {
            good: fetchedData.weryfikacja_6 === 1,
            bad: fetchedData.weryfikacja_6 === 0,
          },
          7: {
            good: fetchedData.weryfikacja_7 === 1,
            bad: fetchedData.weryfikacja_7 === 0,
          },
          8: {
            good: fetchedData.weryfikacja_8 === 1,
            bad: fetchedData.weryfikacja_8 === 0,
          },
          9: {
            good: fetchedData.weryfikacja_9 === 1,
            bad: fetchedData.weryfikacja_9 === 0,
          },
          10: {
            good: fetchedData.weryfikacja_10 === 1,
            bad: fetchedData.weryfikacja_10 === 0,
          },
          11: {
            good: fetchedData.weryfikacja_11 === 1,
            bad: fetchedData.weryfikacja_11 === 0,
          },
          12: {
            good: fetchedData.weryfikacja_12 === 1,
            bad: fetchedData.weryfikacja_12 === 0,
          },
          13: {
            good: fetchedData.weryfikacja_13 === 1,
            bad: fetchedData.weryfikacja_13 === 0,
          },
          14: {
            good: fetchedData.weryfikacja_14 === 1,
            bad: fetchedData.weryfikacja_14 === 0,
          },
          15: {
            good: fetchedData.weryfikacja_15 === 1,
            bad: fetchedData.weryfikacja_15 === 0,
          },
          16: {
            good: fetchedData.weryfikacja_16 === 1,
            bad: fetchedData.weryfikacja_16 === 0,
          },
          17: {
            good: fetchedData.weryfikacja_17 === 1,
            bad: fetchedData.weryfikacja_17 === 0,
          },
          18: {
            good: fetchedData.weryfikacja_18 === 1,
            bad: fetchedData.weryfikacja_18 === 0,
          },
          19: {
            good: fetchedData.weryfikacja_19 === 1,
            bad: fetchedData.weryfikacja_19 === 0,
          },
          20: {
            good: fetchedData.weryfikacja_20 === 1,
            bad: fetchedData.weryfikacja_20 === 0,
          },
          21: {
            good: fetchedData.weryfikacja_21 === 1,
            bad: fetchedData.weryfikacja_21 === 0,
          },
          22: {
            good: fetchedData.weryfikacja_22 === 1,
            bad: fetchedData.weryfikacja_22 === 0,
          },
          23: {
            good: fetchedData.weryfikacja_23 === 1,
            bad: fetchedData.weryfikacja_23 === 0,
          },
          24: {
            good: fetchedData.weryfikacja_24 === 1,
            bad: fetchedData.weryfikacja_24 === 0,
          },
          25: {
            good: fetchedData.weryfikacja_25 === 1,
            bad: fetchedData.weryfikacja_25 === 0,
          },
          26: {
            good: fetchedData.weryfikacja_26 === 1,
            bad: fetchedData.weryfikacja_26 === 0,
          },
        },
        checkboxesInternalControl: {
          1: {
            good: fetchedData.internal_control_1 === 1,
            bad: fetchedData.internal_control_1 === 0,
          },
          2: {
            good: fetchedData.internal_control_2 === 1,
            bad: fetchedData.internal_control_2 === 0,
          },
          3: {
            good: fetchedData.internal_control_3 === 1,
            bad: fetchedData.internal_control_3 === 0,
          },
          4: {
            good: fetchedData.internal_control_4 === 1,
            bad: fetchedData.internal_control_4 === 0,
          },
          5: {
            good: fetchedData.internal_control_5 === 1,
            bad: fetchedData.internal_control_5 === 0,
          },
          6: {
            good: fetchedData.internal_control_6 === 1,
            bad: fetchedData.internal_control_6 === 0,
          },
          7: {
            good: fetchedData.internal_control_7 === 1,
            bad: fetchedData.internal_control_7 === 0,
          },
          8: {
            good: fetchedData.internal_control_8 === 1,
            bad: fetchedData.internal_control_8 === 0,
          },
          9: {
            good: fetchedData.internal_control_9 === 1,
            bad: fetchedData.internal_control_9 === 0,
          },
          10: {
            good: fetchedData.internal_control_10 === 1,
            bad: fetchedData.internal_control_10 === 0,
          },
          11: {
            good: fetchedData.internal_control_11 === 1,
            bad: fetchedData.internal_control_11 === 0,
          },
          12: {
            good: fetchedData.internal_control_12 === 1,
            bad: fetchedData.internal_control_12 === 0,
          },
          13: {
            good: fetchedData.internal_control_13 === 1,
            bad: fetchedData.internal_control_13 === 0,
          },
          14: {
            good: fetchedData.internal_control_14 === 1,
            bad: fetchedData.internal_control_14 === 0,
          },
          15: {
            good: fetchedData.internal_control_15 === 1,
            bad: fetchedData.internal_control_15 === 0,
          },
          16: {
            good: fetchedData.internal_control_16 === 1,
            bad: fetchedData.internal_control_16 === 0,
          },
          17: {
            good: fetchedData.internal_control_17 === 1,
            bad: fetchedData.internal_control_17 === 0,
          },
          18: {
            good: fetchedData.internal_control_18 === 1,
            bad: fetchedData.internal_control_18 === 0,
          },
          19: {
            good: fetchedData.internal_control_19 === 1,
            bad: fetchedData.internal_control_19 === 0,
          },
          20: {
            good: fetchedData.internal_control_20 === 1,
            bad: fetchedData.internal_control_20 === 0,
          },
          21: {
            good: fetchedData.internal_control_21 === 1,
            bad: fetchedData.internal_control_21 === 0,
          },
          22: {
            good: fetchedData.internal_control_22 === 1,
            bad: fetchedData.internal_control_22 === 0,
          },
          23: {
            good: fetchedData.internal_control_23 === 1,
            bad: fetchedData.internal_control_23 === 0,
          },
          24: {
            good: fetchedData.internal_control_24 === 1,
            bad: fetchedData.internal_control_24 === 0,
          },
          25: {
            good: fetchedData.internal_control_25 === 1,
            bad: fetchedData.internal_control_25 === 0,
          },
          26: {
            good: fetchedData.internal_control_26 === 1,
            bad: fetchedData.internal_control_26 === 0,
          },
        },
        nrRef: fetchedData.custom_Nr_Ref || "",
        osobaPrzygotowujaca: fetchedData.OsobaPrzygotowujacaOdprawe || "",
        osobaWeryfikujaca: fetchedData.OsobaWeryfikujacaOdprawe || "",
        comment: fetchedData.comment || "",
        creationDate: fetchedData.created_at || "",
        lastUpdateDate: fetchedData.updated_at || "",
        osoba_kotrolujaca: fetchedData.osoba_kontrolujaca || "",
        data_kontroli: fetchedData.data_kontroli || "",
      };

      setData(mappedData);
      setIsAllInternalControleSaved(allInternalControlSave(mappedData));
      setAllVeryfyingDataFilled(allVeryfyingDataSave(mappedData));
      setAllVerificationSet(checkIfAllVerificationSet(mappedData));
      //verifyAndSubmit(mappedData, status, id, username);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn("Brak rekordu w bazie. Tworzenie domyślnych danych...");

        const defaultData = {
          textFields: {
            19: { value: "", verifyingPerson: "" },
            20: { value: "", verifyingPerson: "" },
            21: { value: "", verifyingPerson: "" },
            25: { value: "", verifyingPerson: "" },
          },
          selectFields: {
            11: { value: "", verifyingPerson: "" },
            23: { value: "", verifyingPerson: "" },
          },
          checkboxesPreparation: {
            1: {
              verifying: "",
              verifyingPerson: "",
            },
            2: {
              verifying: "",
              verifyingPerson: "",
            },
            3: {
              verifying: "",
              verifyingPerson: "",
            },
            4: {
              verifying: "",
              verifyingPerson: "",
            },
            5: {
              verifying: "",
              verifyingPerson: "",
            },
            6: {
              verifying: "",
              verifyingPerson: "",
            },
            7: {
              verifying: "",
              verifyingPerson: "",
            },
            8: {
              verifying: "",
              verifyingPerson: "",
            },
            9: {
              verifying: "",
              verifyingPerson: "",
            },
            10: {
              verifying: "",
              verifyingPerson: "",
            },
            12: {
              verifying: "",
              verifyingPerson: "",
            },
            13: {
              verifying: "",
              verifyingPerson: "",
            },
            14: {
              verifying: "",
              verifyingPerson: "",
            },
            15: {
              verifying: "",
              verifyingPerson: "",
            },
            16: {
              verifying: "",
              verifyingPerson: "",
            },
            17: {
              verifying: "",
              verifyingPerson: "",
            },
            18: {
              verifying: "",
              verifyingPerson: "",
            },
            22: {
              verifying: "",
              verifyingPerson: "",
            },
            24: {
              verifying: "",
              verifyingPerson: "",
            },
            26: {
              verifying: "",
              verifyingPerson: "",
            },
          },
          checkboxesVerification: Object.fromEntries(
            Array.from({ length: 26 }, (_, i) => [
              i + 1,
              { good: false, bad: false },
            ]),
          ),
          checkboxesInternalControl: Object.fromEntries(
            Array.from({ length: 26 }, (_, i) => [
              i + 1,
              { good: false, bad: false },
            ]),
          ),
          nrRef: "",
          osobaPrzygotowujaca: "",
          osobaWeryfikujaca: "",
          comment: "",
          creationDate: "",
          lastUpdateDate: "",
          osoba_kotrolujaca: "",
          data_kontroli: "",
        };

        setData(defaultData);
        setWstepniePrzygotowane(0);
        setCurrentUrzadZgloszenia("");
        setCurrentLokalizacjaTransportu(lokalizacjaTowaru || "");
        setIsAllInternalControleSaved(false);
        setAllVeryfyingDataFilled(false);
        setAllVerificationSet(false);
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAndSetData();
    loadLokalizacjeOdprawList();
    loadLokalizacjeTransportuList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, status]);

  useEffect(() => {
    let isMounted = true;

    const loadKwComments = async () => {
      if (!kwCommentTargetId) {
        if (isMounted) {
          setKwComments([]);
        }
        return;
      }

      try {
        const response = await fetchKwComments(kwCommentTargetId);
        if (isMounted) {
          setKwComments(Array.isArray(response) ? response : []);
        }
      } catch (error) {
        console.error("Nie udało się pobrać komentarzy KW:", error);
        if (isMounted) {
          setKwComments([]);
        }
      }
    };

    loadKwComments();

    return () => {
      isMounted = false;
    };
  }, [kwCommentTargetId]);

  const handleCloseUrzadZgloszeniaDialog = () => {
    setOpenUrzadZgloszeniaDialog(false);
    setPendingDoWyslaniaAction(null);
    setSelectedUrzadZgloszenia("");
    setSelectedLokalizacjaTransportu("");
    setUrzadSearchTerm("");
    setLokalizacjaSearchTerm("");
  };

  const handleConfirmUrzadZgloszeniaDialog = async () => {
    if (!selectedUrzadZgloszenia || !selectedUrzadZgloszenia.trim()) {
      alert("Wybierz Urząd zgłoszenia.");
      return;
    }

    const isLokalizacjaTransportuMissing =
      !currentLokalizacjaTransportu ||
      String(currentLokalizacjaTransportu).trim() === "";
    const lokalizacjaTowaruValue = isLokalizacjaTransportuMissing
      ? String(selectedLokalizacjaTransportu || "").trim()
      : String(currentLokalizacjaTransportu || "").trim();

    if (isLokalizacjaTransportuMissing && !lokalizacjaTowaruValue) {
      alert("Wybierz Lokalizację transportu.");
      return;
    }

    if (!pendingDoWyslaniaAction) {
      handleCloseUrzadZgloszeniaDialog();
      return;
    }

    try {
      if (pendingDoWyslaniaAction.type === "prepared") {
        const payload = {
          statusNow: pendingDoWyslaniaAction.statusNow || status,
          status: "Do wysłania",
          Przygotowane: 1,
          Zweryfikowane: 1,
          wstepniePrzygotowane: 1,
          username: username,
          urzadZgloszenia: selectedUrzadZgloszenia,
          lokalizacjaTowaru: lokalizacjaTowaruValue || null,
        };

        await updateZweryfikowanePrzygotowaneDoWyslania(id, payload, "tranzyt");
      } else if (pendingDoWyslaniaAction.type === "verification") {
        const payload = {
          status: "Do wysłania",
          Zweryfikowane: 1,
          urzadZgloszenia: selectedUrzadZgloszenia,
          lokalizacjaTowaru: lokalizacjaTowaruValue || null,
        };

        await updateStatusDoWyslania(id, payload, "tranzyt");
      }

      alert("Status zmieniony poprawnie.");
      setCurrentUrzadZgloszenia(selectedUrzadZgloszenia);
      setCurrentLokalizacjaTransportu(lokalizacjaTowaruValue || "");
      handleCloseUrzadZgloszeniaDialog();
      setTimeout(() => {
        navigate(
          `/detail/${encodeURIComponent(nrRef)}/${encodeURIComponent(id)}`,
        );
      }, 600);
    } catch (error) {
      console.error("Failed to update status to Do wysłania:", error);
      alert("Wystąpił błąd podczas aktualizacji statusu.");
    }
  };

  const formatDate = (dateTimeString) => {
    const originalDateTime = moment(dateTimeString, "YYYY-MM-DDTHH:mm:ss.SSSZ");

    return originalDateTime.format("DD-MM-YYYY, HH:mm");
  };

  const handleInputChange = (id, field, value) => {
    setData((prevData) => {
      const newData = {
        ...prevData,
        [field]: {
          ...prevData[field],
          [id]: {
            value: value,
            verifyingPerson: username, // Ustawiamy osobę wprowadzającą
          },
        },
      };
      return newData;
    });
  };

  const handleVerificationChange = (id, type) => {
    setData((prevData) => {
      const currentState = prevData.checkboxesVerification[id] || {
        good: false,
        bad: false,
        verifyingPerson: null,
      };

      const newVerification = {
        good: false,
        bad: false,
        verifyingPerson: currentState.verifyingPerson,
      };

      // Jeśli kliknięty checkbox jest już zaznaczony, odznacz go
      if (currentState[type]) {
        newVerification.verifyingPerson = null; // Usuwamy osobę wprowadzającą, jeśli odznaczono
      } else {
        // W przeciwnym razie zaznacz ten checkbox i ustaw osobę wprowadzającą
        newVerification[type] = true;
        newVerification.verifyingPerson = username;
      }

      const newData = {
        ...prevData,
        checkboxesVerification: {
          ...prevData.checkboxesVerification,
          [id]: newVerification,
        },
      };

      return newData;
    });
  };

  const handleInternalControlChange = (id, type) => {
    setData((prevData) => {
      const currentState = prevData.checkboxesInternalControl[id] || {
        good: false,
        bad: false,
      };
      const newVerification = {
        good: currentState.good,
        bad: currentState.bad,
      };

      // Jeśli kliknięty checkbox jest już zaznaczony, odznacz go
      if (currentState[type]) {
        newVerification[type] = false;
      } else {
        // W przeciwnym razie zaznacz ten checkbox i odznacz drugi
        newVerification.good = false;
        newVerification.bad = false;
        newVerification[type] = true;
      }

      const newData = {
        ...prevData,
        checkboxesInternalControl: {
          ...prevData.checkboxesInternalControl,
          [id]: newVerification,
        },
      };

      return newData;
    });
  };

  const handleCommentChange = (e) => {
    setData((prevData) => ({
      ...prevData,
      comment: e.target.value,
    }));
  };

  const handleCommentChangeInternalControl = (e) => {
    setData((prevData) => ({
      ...prevData,
      comment: e.target.value,
    }));
  };

  const rows = [
    {
      id: 1,
      check: "1. Korespondencja umieszczona w folderze wskazanym w systemie",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 2,
      check: "2. Kontrahent otrzymał ticket",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 3,
      check: "3. Przygotowano plik do zaczytania do HUZAR",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 4,
      check: "4. Poprawny numer referencyjny z systemu wpisany w SAD",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 5,
      check: "5. Dane nadawcy",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 6,
      check: "6. Dane odbiorcy",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 7,
      check: "7. Kod kraju przeznaczenia",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 8,
      check: "8. Waluta i kwota na fakturze",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 9,
      check: "9. Rodzaj transakcji",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 10,
      check: "10. Opis towaru i tłumaczenie",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 11,
      check:
        "11. Wybierz czy kraje transakcji objęte są embargiem lub sankcjami",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 12,
      check: "12. Czy zastosowano właściwą procedurę celną",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 13,
      check: "13. Taryfikacja towaru",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 14,
      check: "14. Numer i typ faktury",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 15,
      check: "15. Masa brutto",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 16,
      check: "16. Masa netto",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 17,
      check: "17. Rodzaj i liczba opakowań",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 18,
      check: "18. Rodzaj przedstawicielstwa",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 19,
      check: "19. Wpisz urząd tranzytowy",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 20,
      check: "20. Wpisz urząd przeznaczenia",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 21,
      check: "21. Wpisz nr środka transportu/nr listu",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 22,
      check: "22. Kraj przynależności środka transportu",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 23,
      check: "23. Wybierz INCOTERMS",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 24,
      check: "24. Koszty transportu",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 25,
      check: "25. Wpisz urząd celny wyjścia",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
    {
      id: 26,
      check: "26. Numer listu przewozowego",
      verifying: false,
      verifyingPerson: false,
      internalControl: false,
    },
  ];

  const updateStatusToPrePrepared = async () => {
    if (
      areSpecificFieldsDisabled &&
      status === "Do przygotowania" &&
      wstepniePrzygotowane !== 1
    ) {
      try {
        const payload = {
          status: "Wstępnie przygotowane", // Nowy status
          wstepniePrzygotowane: 1, // Zmiana wartości w bazie
          username: username,
        };
        const response = await updateStatusWstepnie(id, payload); // Wyślij żądanie do API
        alert(response.message); // Pokaż wiadomość użytkownikowi
        navigate(
          `/detail/${encodeURIComponent(nrRef)}/${encodeURIComponent(id)}`,
        );
      } catch (error) {
        console.error("Failed to update status:", error);
        alert("Wystąpił błąd podczas aktualizacji statusu!");
      }
    }
  };

  const saveData = async () => {
    const processFieldValues = (fields) =>
      Object.fromEntries(
        Object.entries(fields).map(([key, value]) => [
          key,
          {
            value: value.value === "0" ? "" : value.value,
            verifyingPerson: value.verifyingPerson,
          },
        ]),
      );

    const payload = {
      textFields: processFieldValues(data.textFields),
      selectFields: processFieldValues(data.selectFields),
      checkboxes: Object.fromEntries(
        Object.entries(data.checkboxesPreparation).map(([key, value]) => [
          key,
          {
            verifying: value.verifying,
            verifyingPerson: value.verifyingPerson,
          },
        ]),
      ),
      nrRef,
      osobaPrzygotowujaca,
      osobaWeryfikujaca,
      comment: data.comment,
    };

    try {
      const response = await saveOrUpdateData(id, payload);
      alert(response.message);

      const verifyResult = await verifyAndSubmit(data, status, id, username);
      if (verifyResult === "pendingDialog") {
        return;
      }

      // verifyAndSubmit zmieniło już status (Do wysłania / Do weryfikacji) - nie wolno go
      // nadpisywać statusem "Wstępnie przygotowane" na podstawie nieaktualnego stanu komponentu.
      if (verifyResult === "statusChanged") {
        return;
      }

      await fetchAndSetData();

      if (wstepniePrzygotowane !== 1) {
        await updateStatusToPrePrepared();
      }
    } catch (error) {
      console.error("Failed to save or update data:", error);
      alert("Wystąpił błąd podczas zapisywania danych!");
    }
  };

  const saveInternalControlData = async () => {
    try {
      const allCheckboxesHaveValue = Object.entries(
        data.checkboxesInternalControl,
      ).every(
        ([key, checkbox]) =>
          key === "13" || checkbox.good === true || checkbox.bad === true,
      );

      if (!allCheckboxesHaveValue) {
        alert(
          "Wszystkie pola muszą być uzupełnione przed zapisaniem danych oprócz pola 13. Taryfikacja towaru.",
        );
        return;
      }

      // Dodanie numeru referencyjnego
      const payload = {
        checkboxesInternalControl: data.checkboxesInternalControl,
        nrRef: nrRef,
        osobaWeryfikujacaOdpraw: osobaWeryfikujaca,
        osobaPrzygotowujacaOdprawe: osobaPrzygotowujaca,
      };

      const response = await saveOrUpdateData(id, payload);

      // Obsługa komentarza
      if (data.comment) {
        const commentPayload = {
          comment: data.comment,
          username: username,
        };
        await saveComment(id, commentPayload);
        await saveKwComment(kwCommentTargetId, commentPayload);
      }

      const secondPayload = {
        nrRef: nrRef,
        osoba_kontrolujaca: username,
        data_kontroli: format(
          utcToZonedTime(new Date(), "Europe/Warsaw"),
          "yyyy-MM-dd'T'HH:mm:ssXXX",
        ),
      };

      await saveInternalControlDataDates(id, secondPayload);

      alert(response.message);
      window.location.reload();
    } catch (error) {
      console.error("Failed to save internal control data or comment:", error);
      alert(
        "Wystąpił błąd podczas zapisywania danych kontroli wewnętrznej lub komentarza!",
      );
    }
  };

  const saveVerifyingData = async () => {
    if (status === "Do wysłania") {
      return;
    }

    const allCheckboxesHaveValue = Object.values(
      data.checkboxesVerification,
    ).every((checkbox) => checkbox.good === true || checkbox.bad === true);

    if (!allCheckboxesHaveValue) {
      const payload = {
        checkboxes: data.checkboxesVerification,
        nrRef: nrRef,
        osobaWeryfikujaca: osobaWeryfikujaca,
        comment: data.comment,
      };

      try {
        const response = await saveVerifyingData1(id, payload);
        alert(response.message);
      } catch (error) {
        console.error("Failed to save verifying data:", error);
        alert("Wystąpił błąd podczas zapisywania danych weryfikujących!");
      }
      return;
    }

    const allCheckboxesVerified = Object.values(
      data.checkboxesVerification,
    ).every((checkbox) => checkbox.good === true);

    if (allCheckboxesVerified) {
      const payload = {
        checkboxes: data.checkboxesVerification,
        nrRef: nrRef,
        osobaWeryfikujaca: osobaWeryfikujaca,
        comment: data.comment,
      };

      try {
        const response = await saveVerifyingData1(id, payload);
        alert(response.message);

        setPendingDoWyslaniaAction({
          type: "verification",
          statusNow: status,
        });
        setSelectedUrzadZgloszenia(currentUrzadZgloszenia || "");
        setSelectedLokalizacjaTransportu(currentLokalizacjaTransportu || "");
        setOpenUrzadZgloszeniaDialog(true);
      } catch (error) {
        console.error("Failed to save verifying data or update status:", error);
        alert(
          "Wystąpił błąd podczas zapisywania danych weryfikujących lub aktualizacji statusu!",
        );
      }
    } else {
      if (!data.comment || data.comment.length === 0) {
        alert(
          "Wystąpił błąd podczas zapisywania danych, komentarz nie może być pusty!",
        );
        return;
      }

      try {
        const payload = {
          checkboxes: data.checkboxesVerification,
          nrRef: nrRef,
          osobaWeryfikujaca: osobaWeryfikujaca,
          comment: data.comment,
        };

        const response = await saveVerifyingData1(id, payload);
        alert(response.message);

        const commentPayload = {
          comment: data.comment,
          username: osobaWeryfikujaca,
        };
        const statusPayload = {
          status: "Do poprawy",
          Zweryfikowane: 0,
        };

        await saveComment(id, commentPayload);
        await updateStatusDoPoprawy(id, statusPayload, "tranzyt");
        await saveCheckbox(id, { zglosBladBox: 1 });
        setTimeout(() => {
          navigate(
            `/detail/${encodeURIComponent(nrRef)}/${encodeURIComponent(id)}`,
          );
        }, 1500);
      } catch (error) {
        console.error(
          "Failed to save verifying data, comment, or update status:",
          error,
        );
        alert(
          "Wystąpił błąd podczas zapisywania danych weryfikujących, komentarza lub aktualizacji statusu!",
        );
      }
    }
  };

  if (
    loading ||
    wstepniePrzygotowane === undefined ||
    !status ||
    !username ||
    privileges === undefined ||
    !privileges
  ) {
    return (
      <div className={classes.loader}>
        <CircularProgress />
        <div>Pobieranie danych...</div>
      </div>
    );
  }

  const isFieldDisabled = (rowId) => {
    const isStatusValid =
      status === "Do przygotowania" || status === "Wstępnie przygotowane";
    const isWithinBlockedRange =
      wstepniePrzygotowane === 1 && rowId >= 1 && rowId <= 14;
    const hasUserPermission =
      username === osobaPrzygotowujaca || username === osobaWysylajaca;
    const isAllDataFilled = przygotowane === 1 && rowId >= 1 && rowId <= 25;

    return (
      !isStatusValid ||
      isWithinBlockedRange ||
      !hasUserPermission ||
      isAllDataFilled
    );
  };

  const handleCheckAllGood = () => {
    setData((prevData) => {
      const updatedCheckboxesInternalControl = Object.fromEntries(
        Object.entries(prevData.checkboxesInternalControl).map(
          ([key, value]) => [
            key,
            { ...value, good: true, bad: false }, // opcjonalnie ustawiasz `bad` na false, żeby nie było konfliktów
          ],
        ),
      );

      return {
        ...prevData,
        checkboxesInternalControl: updatedCheckboxesInternalControl,
      };
    });
  };

  const handleCheckAllPrepared = () => {
    setData((prevData) => {
      const updatedCheckboxesPreparation = Object.fromEntries(
        Object.entries(prevData.checkboxesPreparation)
          .filter(([key]) => {
            const num = Number(key);
            return num >= 1 && num <= 14;
          })
          .map(([key, value]) => [
            key,
            {
              ...value,
              verifying: !isAllPreparedChecked, // zmienia się na true/false zależnie od stanu
              verifyingPerson: !isAllPreparedChecked ? username : "",
            },
          ]),
      );

      return {
        ...prevData,
        checkboxesPreparation: {
          ...prevData.checkboxesPreparation,
          ...updatedCheckboxesPreparation,
        },
      };
    });

    // przełącz stan
    setIsAllPreparedChecked((prev) => !prev);
  };

  const handleCheckOnlyEmptyPrepared = () => {
    setData((prevData) => {
      const updatedCheckboxesPreparation = Object.fromEntries(
        Object.entries(prevData.checkboxesPreparation).map(([key, value]) => {
          if (isAllChecked) {
            // Jeśli chcemy odznaczyć — ustaw wszystko na false
            return [
              key,
              {
                ...value,
                verifying: false,
                verifyingPerson: "",
              },
            ];
          } else {
            // Jeśli chcemy zaznaczyć tylko te, które są jeszcze puste
            if (!value.verifying) {
              return [
                key,
                {
                  ...value,
                  verifying: true,
                  verifyingPerson: username,
                },
              ];
            }
            return [key, value]; // nie zmieniaj tych już zaznaczonych
          }
        }),
      );

      return {
        ...prevData,
        checkboxesPreparation: {
          ...prevData.checkboxesPreparation,
          ...updatedCheckboxesPreparation,
        },
      };
    });

    setIsAllChecked((prev) => !prev);
  };

  const exportPDF = () => {
    const input = ref.current;

    input.classList.add(classes["pdfContainerExport"]);

    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      input.classList.remove(classes["pdfContainerExport"]);

      const imgWidth = 210; // A4 mm
      const pageHeight = 297; // A4 mm
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const pxPerMm = canvasWidth / imgWidth;
      const pageHeightPx = (pageHeight - 41) * pxPerMm; // przesuwa cięcie 10mm wyżej

      let position = 0;

      const pdf = new jsPDF("p", "mm", "a4");

      const logo = new Image();
      logo.src = "/logo-wega.jpg"; // logo z public/

      logo.onload = () => {
        while (position < canvasHeight) {
          const canvasPage = document.createElement("canvas");
          canvasPage.width = canvasWidth;
          canvasPage.height = Math.min(pageHeightPx, canvasHeight - position);

          const ctx = canvasPage.getContext("2d");
          ctx.drawImage(
            canvas,
            0,
            position,
            canvasWidth,
            canvasPage.height,
            0,
            0,
            canvasWidth,
            canvasPage.height,
          );

          const pageData = canvasPage.toDataURL("image/jpeg", 0.6); // 0.6 = jakość 60%

          const pageImgHeight = (canvasPage.height * imgWidth) / canvasWidth;

          if (position !== 0) pdf.addPage();

          // Dodaj logo w prawym górnym rogu (30x15mm)
          pdf.addImage(logo, "JPEG", 170, 2, 30, 30);

          // Tytuł u góry na środku
          const title = `Lista kontrolna ${rodzajOdprawy} - nr Ref: ${nrRef}`;
          pdf.setFontSize(16);
          pdf.text(title, imgWidth / 2, 15, { align: "center" });

          // Zawartość strony (poniżej nagłówka)
          pdf.addImage(pageData, "PNG", 0, 25, imgWidth, pageImgHeight);

          position += pageHeightPx;
        }

        pdf.save(`lista_kontrolna_eksport_${nrRef}.pdf`);
      };
    });
  };

  const handleSave = async () => {
    try {
      const payload = {
        username,
        selectedOption,
        ...(selectedOption === "1" || selectedOption === "2"
          ? { comment }
          : {}),
      };
      await resetList(id, nrRef, payload);
      alert("Zapisano poprawnie");
      setOpenResetDialog(false);
      setSelectedOption("");
      setComment("");
      navigate(
        `/detail/${encodeURIComponent(nrRef)}/${encodeURIComponent(id)}`,
      );
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd przy zapisie");
    }
  };

  const handleSaveInternalControl = async () => {
    try {
      const payload = {
        username,
        comment: `Powód resetu LK kontrola wewnętrzna: ${commentInternalControl}`,
      };
      await resetInternalControl(id, nrRef, payload);
      alert("Zapisano poprawnie");
      setOpenResetInternalControlDialog(false);
      setSelectedOptionInternalControl("");
      setCommentInternalControl("");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd przy zapisie");
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap>
            Nr. Ref: {nrRef}, Rodzaj odprawy: {rodzajOdprawy}, Status: {status},
            Osoba przygotowująca: {osobaPrzygotowujaca}, Osoba weryfikująca:{" "}
            {osobaWeryfikujaca}, Osoba wysyłająca: {osobaWysylajaca}
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{ paper: classes.drawerPaper }}
      >
        <Toolbar />
        <List>
          <ListItem button onClick={handleBackNavigation}>
            <ListItemIcon>
              <ArrowBackIcon />
            </ListItemIcon>
            <ListItemText primary={returnLabel || "Powrót do tabeli"} />
          </ListItem>
          <ListItem button onClick={() => navigate("/login")}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary="Wyloguj" />
          </ListItem>
        </List>
      </Drawer>
      <main className={classes.content}>
        <Toolbar />
        {/* Dodany przycisk tutaj */}
        <Button
          variant="contained"
          color="primary"
          onClick={exportPDF}
          style={{ marginBottom: "20px" }}
        >
          Pobierz PDF
        </Button>
        {(role === "admin" || role === "manager") && (
          <>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpenResetDialog(true)}
              style={{ marginBottom: "20px" }}
            >
              Resetuj listę
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpenResetInternalControlDialog(true)}
              style={{ marginBottom: "20px", marginLeft: "10px" }}
            >
              Resetuj kontrolę wewnętrzną
            </Button>

            <ResetListDialog
              open={openResetDialog}
              onClose={() => setOpenResetDialog(false)}
              onSave={handleSave}
              selectedOption={selectedOption}
              comment={comment}
              setSelectedOption={setSelectedOption}
              setComment={setComment}
            />

            <ResetListDialog
              open={openResetInternalControlDialog}
              onClose={() => setOpenResetInternalControlDialog(false)}
              onSave={handleSaveInternalControl}
              selectedOption={selectedOptionInternalControl}
              comment={commentInternalControl}
              setSelectedOption={setSelectedOptionInternalControl}
              setComment={setCommentInternalControl}
              title="Resetuj kontrolę wewnętrzną - podaj komentarz:"
              showRadioGroup={false}
            />
          </>
        )}
        <div ref={ref} className={classes.pdfContainer}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" className={classes.tableHeadCell}>
                    Sprawdź
                  </TableCell>
                  <TableCell align="center" className={classes.tableHeadCell}>
                    Osoba przygotowująca
                  </TableCell>
                  <TableCell align="center" className={classes.tableHeadCell}>
                    Osoba wprowadzająca
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableHeadCell}
                    colSpan={2}
                  >
                    Osoba weryfikująca
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableHeadCell}
                    colSpan={2}
                  >
                    Kontrola wewnętrzna
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableHeadCell}></TableCell>
                  <TableCell className={classes.tableHeadCell}></TableCell>
                  <TableCell className={classes.tableHeadCell}></TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableSubHeadCell}
                  >
                    Poprawnie
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableSubHeadCell}
                  >
                    Niepoprawnie
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableSubHeadCell}
                  >
                    Poprawnie
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableSubHeadCell}
                  >
                    Niepoprawnie
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.id}
                    className={`${classes.tableRow} ${
                      row.id >= 15 && row.id <= 26 ? classes.greyRow : ""
                    }`}
                  >
                    <TableCell className={classes.checkCell}>
                      {row.check}
                    </TableCell>
                    <TableCell className={classes.centered}>
                      {[19, 20, 21, 25].includes(row.id) ? (
                        <TextField
                          className={classes.inputField}
                          value={data.textFields[row.id]?.value || ""}
                          onChange={(e) =>
                            handleInputChange(
                              row.id,
                              "textFields",
                              e.target.value,
                            )
                          }
                          variant="outlined"
                          size="small"
                          disabled={isFieldDisabled(row.id)}
                        />
                      ) : [11, 23].includes(row.id) ? (
                        <Select
                          className={classes.inputField}
                          value={data.selectFields[row.id]?.value || ""}
                          onChange={(e) =>
                            handleInputChange(
                              row.id,
                              "selectFields",
                              e.target.value,
                            )
                          }
                          displayEmpty
                          disabled={isFieldDisabled(row.id)}
                        >
                          {selectOptions[row.id].map((option, index) => (
                            <MenuItem key={index} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        <Checkbox
                          checked={
                            data.checkboxesPreparation[row.id]?.verifying ||
                            false
                          }
                          onChange={(e) => {
                            const newChecked = e.target.checked;
                            setData((prevData) => ({
                              ...prevData,
                              checkboxesPreparation: {
                                ...prevData.checkboxesPreparation,
                                [row.id]: {
                                  verifying: newChecked,
                                  verifyingPerson: newChecked ? username : "",
                                },
                              },
                            }));
                          }}
                          color="primary"
                          disabled={isFieldDisabled(row.id)}
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {data.textFields[row.id]?.verifyingPerson ||
                        data.selectFields[row.id]?.verifyingPerson ||
                        data.checkboxesPreparation[row.id]?.verifyingPerson}
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        checked={
                          data.checkboxesVerification[row.id]?.good || false
                        }
                        onChange={() =>
                          handleVerificationChange(row.id, "good")
                        }
                        color="primary"
                        disabled={
                          username !== osobaWeryfikujaca ||
                          allVeryfyingDataFilled ||
                          allVerificationSet
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Checkbox
                        checked={
                          data.checkboxesVerification[row.id]?.bad || false
                        }
                        onChange={() => handleVerificationChange(row.id, "bad")}
                        color="secondary"
                        disabled={
                          username !== osobaWeryfikujaca || allVerificationSet
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Checkbox
                        checked={
                          data.checkboxesInternalControl[row.id]?.good || false
                        }
                        onChange={() =>
                          handleInternalControlChange(row.id, "good")
                        }
                        color="primary"
                        disabled={
                          privileges.internalControl !== 1 ||
                          isAllInternalControleSaved
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Checkbox
                        checked={
                          data.checkboxesInternalControl[row.id]?.bad || false
                        }
                        onChange={() =>
                          handleInternalControlChange(row.id, "bad")
                        }
                        color="secondary"
                        disabled={
                          privileges.internalControl !== 1 ||
                          isAllInternalControleSaved
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div style={{ marginTop: "20px" }}>
            {formatDate(data.creationDate) !== "Invalid date" && (
              <Typography variant="body1">
                Data utworzenia listy: {formatDate(data.creationDate)}
              </Typography>
            )}
            {formatDate(data.lastUpdateDate) !== "Invalid date" && (
              <Typography variant="body1">
                Data ostatniej aktualizacji: {formatDate(data.lastUpdateDate)}
              </Typography>
            )}
            {formatDate(data.data_kontroli) !== "Invalid date" && (
              <Typography variant="body1">
                Data wykonania kontroli wewnętrznej:{" "}
                {formatDate(data.data_kontroli)} wykonanej przez użytkownika:{" "}
                {data.osoba_kotrolujaca}
              </Typography>
            )}
          </div>

          <div style={{ marginTop: "20px" }}>
            <Typography variant="h6">
              Komentarze z Kontroli Wewnętrznej
            </Typography>
            {kwComments.length > 0 ? (
              kwComments.map((item) => (
                <Paper
                  key={
                    item.id ||
                    `${item.username || "anon"}-${item.createdAt || "no-date"}`
                  }
                  variant="outlined"
                  style={{ padding: "12px", marginTop: "10px" }}
                >
                  <Typography variant="subtitle2">
                    Autor: {item.username || "-"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {formatDate(item.createdAt || item.timestamp) !==
                    "Invalid date"
                      ? formatDate(item.createdAt || item.timestamp)
                      : "-"}
                  </Typography>
                  <Typography style={{ whiteSpace: "pre-wrap", marginTop: 8 }}>
                    {item.comment || "-"}
                  </Typography>
                </Paper>
              ))
            ) : (
              <Typography variant="body2" color="textSecondary">
                Brak komentarzy dla tego wpisu KW.
              </Typography>
            )}
          </div>
        </div>

        {username === osobaWeryfikujaca && (
          <>
            <TextField
              label="Napisz co było nie tak"
              multiline
              rows={4}
              value={data.comment}
              onChange={handleCommentChange}
              variant="outlined"
              fullWidth
              margin="normal"
              disabled={allVeryfyingDataFilled} // Dodanie allVerificationSet do warunku disabled
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={saveVerifyingData}
              style={{ marginTop: "20px" }}
              disabled={allVeryfyingDataFilled} // Dodanie allVerificationSet do warunku disabled
            >
              Zapisz dane weryfikacyjne
            </Button>
          </>
        )}
        {(username === osobaPrzygotowujaca || username === osobaWysylajaca) && (
          <>
            <Button
              variant="contained"
              color="primary"
              style={{
                marginTop: "20px",
                marginRight: "20px",
                whiteSpace: "pre-line",
              }}
              onClick={handleCheckAllPrepared}
              disabled={
                status === "Zrealizowane" ||
                (username !== osobaPrzygotowujaca &&
                  username !== osobaWysylajaca)
              }
            >
              {isAllPreparedChecked
                ? `Odznacz wszystkie znaczniki \nlisty wstępnego przygotowania`
                : `Zaznacz wszystkie znaczniki \nlisty wstępnego przygotowania`}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                marginTop: "20px",
                marginRight: "20px",
                whiteSpace: "pre-line",
              }}
              onClick={handleCheckOnlyEmptyPrepared}
              disabled={
                status === "Zrealizowane" ||
                (username !== osobaPrzygotowujaca &&
                  username !== osobaWysylajaca)
              }
            >
              {isAllChecked
                ? `Odznacz wszystkie znaczniki`
                : `Zaznacz wszystkie znaczniki`}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={saveData}
              style={{ marginTop: "20px" }}
              disabled={
                status === "Zrealizowane" ||
                (username !== osobaPrzygotowujaca &&
                  username !== osobaWysylajaca)
              }
            >
              Zapisz dane
            </Button>
          </>
        )}
        {privileges.internalControl === 1 && (
          <>
            <TextField
              label="Napisz jeśli chcesz komentarz do kontroli wewnętrznej"
              multiline
              rows={4}
              value={data.comment}
              onChange={handleCommentChangeInternalControl}
              variant="outlined"
              fullWidth
              margin="normal"
              disabled={isAllInternalControleSaved}
            />
            <Button
              variant="contained"
              color="primary"
              style={{
                marginTop: "20px",
                marginRight: "20px",
                whiteSpace: "pre-line",
              }}
              onClick={handleCheckAllGood}
              disabled={isAllInternalControleSaved}
            >
              {`Zaznacz wszystkie dane kontroli wewnętrznej\n jako poprawne`}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={saveInternalControlData}
              style={{ marginTop: "20px" }}
              disabled={isAllInternalControleSaved}
            >
              Zapisz dane kontroli wewnętrznej
            </Button>
          </>
        )}

        <Dialog
          open={openUrzadZgloszeniaDialog}
          onClose={handleCloseUrzadZgloszeniaDialog}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle style={{ whiteSpace: "pre-line" }}>
            {
              "Wybierz Urząd zgłoszenia i lokalizacje transportu.\nStatus zmieni się na Do wysłania lub Do weryfikacji"
            }
          </DialogTitle>
          <DialogContent>
            <TextField
              select
              fullWidth
              label="Urząd zgłoszenia"
              value={selectedUrzadZgloszenia}
              onChange={(e) => setSelectedUrzadZgloszenia(e.target.value)}
              margin="dense"
              required
              SelectProps={{
                MenuProps: {
                  getContentAnchorEl: null,
                },
              }}
            >
              <ListSubheader>
                <TextField
                  size="small"
                  autoFocus
                  placeholder="Szukaj urzędu..."
                  fullWidth
                  value={urzadSearchTerm}
                  onChange={(e) => setUrzadSearchTerm(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                />
              </ListSubheader>
              {filteredUrzadZgloszeniaOptions.map((item) => (
                <MenuItem key={item.id} value={item.name}>
                  {item.name}
                </MenuItem>
              ))}
              {filteredUrzadZgloszeniaOptions.length === 0 && (
                <MenuItem disabled>Brak wyników</MenuItem>
              )}
            </TextField>
            {(!currentLokalizacjaTransportu ||
              String(currentLokalizacjaTransportu).trim() === "") && (
              <TextField
                select
                fullWidth
                label="Lokalizacja transportu"
                value={selectedLokalizacjaTransportu}
                onChange={(e) =>
                  setSelectedLokalizacjaTransportu(e.target.value)
                }
                margin="dense"
                required
                SelectProps={{
                  MenuProps: {
                    getContentAnchorEl: null,
                  },
                }}
              >
                <ListSubheader>
                  <TextField
                    size="small"
                    placeholder="Szukaj lokalizacji..."
                    fullWidth
                    value={lokalizacjaSearchTerm}
                    onChange={(e) => setLokalizacjaSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                </ListSubheader>
                {filteredLokalizacjaTransportuOptions.map((item) => (
                  <MenuItem key={item.id} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
                {filteredLokalizacjaTransportuOptions.length === 0 && (
                  <MenuItem disabled>Brak wyników</MenuItem>
                )}
              </TextField>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseUrzadZgloszeniaDialog}
              color="secondary"
            >
              Anuluj
            </Button>
            <Button
              onClick={handleConfirmUrzadZgloszeniaDialog}
              color="primary"
              variant="contained"
              disabled={
                !selectedUrzadZgloszenia ||
                !selectedUrzadZgloszenia.trim() ||
                ((!currentLokalizacjaTransportu ||
                  String(currentLokalizacjaTransportu).trim() === "") &&
                  (!selectedLokalizacjaTransportu ||
                    !selectedLokalizacjaTransportu.trim()))
              }
            >
              Zatwierdź
            </Button>
          </DialogActions>
        </Dialog>
      </main>
    </div>
  );
};
export default UniwersalListTranzyt;
